import styled from 'styled-components';

export const Container = styled.form`
  width: 100%;  
`;
